module.exports = __webpack_public_path__ + "img/hamptoninn-logo.5acfaf21.jpg";